import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Practice } from './practice.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PracticeService {
  static PRACTICE_URL = 'practice';

  constructor(private http: HttpClient) {}

  getPracticeData(): Observable<Practice> {
    return this.http.get<Practice>(PracticeService.PRACTICE_URL);
  }
}
